import React, { useState } from "react";
import { Container, Row, Col, Button, Nav, Navbar, Card, Accordion, Image, Form, InputGroup } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaPlus, FaMinus } from "react-icons/fa";
import '../styles/Style.css';
import WebNav from "../components/WebNav";

const HomePage = () => {

  const howItWorksSteps = [
    {
      title: "Buy QR Codes",
      image: "/images/work-1.png",
      description: "Subscribe and get your unique QR labels delivered to your door."
    },
    {
      title: "Set as TAG or CATALOGUE",
      image: "/images/work-2.png",
      description: "Tags are for personal items, Catalogues are for collections."
    },
    {
      title: "Configure Details",
      image: "/images/work-3.png",
      description: "Add secure info (only you or your group can see)."
    },
    {
      title: "Scan & Act",
      image: "/images/work-4.png",
      description: "Public sees a contact form. You see your item details."
    }
  ];

  const getStartedSteps = [
    {
      image: "/images/1.png",
      title: "Subscribe to a plan",
      description: "Choose the plan that fits your needs, from individual to family or business."
    },
    {
      image: "/images/2.png",
      title: "Receive QR codes",
      description: "Your durable, high-quality QR code labels will be delivered to your address."
    },
    {
      image: "/images/3.png",
      title: "Start tagging",
      description: "Attach labels to your items and configure them through our easy-to-use app."
    }
  ];

  const faqs = [
    {
      question: "Can I manage multiple items?",
      answer: "Yes, our system supports item-level tagging and cataloguing."
    },
    {
      question: "Can I share access with family or team members?",
      answer: "Absolutely, you can share catalogues securely."
    },
    {
      question: "Is my info visible to the public?",
      answer: "No, your personal info is never exposed."
    },
    {
      question: "Can I update the information linked to a QR code later?",
      answer: "Yes, all info can be updated via your dashboard anytime."
    },
    {
      question: "What's the difference between a TAG and a CATALOGUE?",
      answer: "A TAG is for single items, while a CATALOGUE manages grouped items."
    },
    {
      question: "Can I use it for my business inventory?",
      answer: "Yes, it's perfect for small and medium businesses to manage assets."
    },
    {
      question: "What happens if someone scans my tag?",
      answer: "They will be shown a secure contact form—your private info is hidden."
    },
    {
      question: "Can I receive alerts or notifications?",
      answer: "Yes, you will be notified when your tag is scanned or a message is sent."
    }
  ];

  const [activeKey, setActiveKey] = useState(null);

  const toggleAccordion = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  return (
    <div style={{ fontFamily: 'Segoe UI, sans-serif', backgroundColor: '#fff' }}>
      {/* Navbar */}
      <WebNav />

      {/* Hero Section */}
      <section style={{ backgroundColor: '#e9f1ff', padding: '80px 0 0px 0px' }}>
        <Container>
          <Row className="align-items-center">
            <Col md={6} className="text-center text-md-start">
              <h1 className="fw-bold mb-3 text-dark">
                Lost and Found—Reinvented<br />with <span className="text-primary">Smart QR Labels.</span>
              </h1>
              <p className="text-muted mb-4">
                Tag your Luggage, Keys, Or Anything Valuable. Let Finders Contact You Without Exposing Your Personal Info.
              </p>
              <div className="d-flex gap-3 flex-wrap justify-content-center justify-content-md-start">
                <Button variant="primary" className="px-4 rounded">Buy Your Tags</Button>
                <Button variant="outline-primary" className="px-4 rounded">See How It Works</Button>
              </div>
            </Col>
            <Col
            md={6}
            className="d-flex justify-content-center justify-content-md-end align-items-end mt-4 mt-md-0"
            style={{ height: '100%' }}
          >
            <Image
              src="/images/hero-image.png"
              alt="Hero"
              fluid
              style={{ maxHeight: '420px', objectFit: 'contain' }}
            />
          </Col>
          </Row>
        </Container>
      </section>

      {/* How It Works Section */}
      <Container className="py-5" id="how">
        <div className="text-center mb-4">
          <div className="d-flex align-items-center justify-content-center mb-2">
            <div style={{ height: '1px', backgroundColor: '#ccc', width: '60px', marginRight: '10px' }}></div>
            <span className="text-uppercase text-primary" style={{ letterSpacing: '2px', fontWeight: 600 }}>work</span>
            <div style={{ height: '1px', backgroundColor: '#ccc', width: '60px', marginLeft: '10px' }}></div>
          </div>
          <h3 className="text-black fw-bold">How It Works</h3>
          <p className="text-muted">Our solution offers unmatched security and convenience for all your valuable items.</p>
        </div>
        <Row className="g-4">
          {howItWorksSteps.map((step, idx) => (
            <Col md={6} lg={3} key={idx}>
              <Card className="h-100 text-center border-0 shadow-sm" style={{backgroundColor: '#e9f1ff'}}>
                <Card.Img
                  variant="top"
                  src={step.image}
                  style={{ width: '35%', height: 'auto', margin: '0 auto', paddingTop: '15px' }}
                />
                <Card.Body>
                  <Card.Title className="fw-bold pt-3" style={{fontSize:'18px'}}>{step.title}</Card.Title>
                  <Card.Text>{step.description}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Why QRKey Section */}
      <div style={{ backgroundColor: '#e9f1ff' }}>
        <Container className="py-5" id="why">
          <div className="text-center mb-4">
            <div className="d-flex align-items-center justify-content-center mb-2">
              <div style={{ height: '1px', backgroundColor: '#ccc', width: '60px', marginRight: '10px' }}></div>
              <span className="text-uppercase text-primary" style={{ letterSpacing: '2px', fontWeight: 600 }}>Why</span>
              <div style={{ height: '1px', backgroundColor: '#ccc', width: '60px', marginLeft: '10px' }}></div>
            </div>
            <h3 className="text-black fw-bold">Why QRKey?</h3>
            <p className="text-muted">Our solution offers unmatched security and convenience for all your valuable items.</p>
          </div>
          <Row className="align-items-center">
            <Col md={6} className="mb-4">
              <Image src="/images/why-qr.jpg" fluid rounded />
            </Col>
            <Col md={6}>
              <div className="mb-4">
                <h5 className="text-black fw-bold">Fully private & secure</h5>
                <p className="text-muted">Your personal information is never exposed to the public, ensuring complete privacy.</p>
              </div>
              <div className="mb-4">
                <h5 className="text-black fw-bold">Secure communication</h5>
                <p className="text-muted">Public can contact you through a secure form without seeing your personal details.</p>
              </div>
              <div className="mb-4">
                <h5 className="text-black fw-bold">Share with family or group</h5>
                <p className="text-muted">Easily share access to your catalogues with family members or team members.</p>
              </div>
              <div className="mb-4">
                <h5 className="text-black fw-bold">Easy to use, smart & safe</h5>
                <p className="text-muted">Intuitive interface makes it simple to manage all your tagged items from any device.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Services Section */}
      <Container className="py-5" id="services">
        <div className="text-center mb-4">
          <div className="d-flex align-items-center justify-content-center mb-2">
            <div style={{ height: '1px', backgroundColor: '#ccc', width: '60px', marginRight: '10px' }}></div>
            <span className="text-uppercase text-primary" style={{ letterSpacing: '2px', fontWeight: 600 }}>Services</span>
            <div style={{ height: '1px', backgroundColor: '#ccc', width: '60px', marginLeft: '10px' }}></div>
          </div>
          <h3 className="text-black fw-bold">Two Powerful Services</h3>
          <p className="text-muted">Choose the right solution for your needs, whether you're tagging personal items or organizing collections.</p>
        </div>
        <Row className="g-4">
          <Col md={6}>
            <Card className="h-100 border-0 shadow text-center pt-2" style={{backgroundColor: '#e9f1ff'}}>
              <div className="text-center w-100 py-3">
                <Image
                  src="/images/service-1.jpg"
                  alt="TAGS"
                  style={{ width: '90%', maxWidth: '100%', height: 'auto' }}
                />
              </div>
              <Card.Body  className="text-start">
                <Card.Title className="fw-bold" style={{ color: '#000' }}>TAGS</Card.Title>
                <Card.Text className="text-muted">
                  For everyday items like luggage, keys, bags.
                  <ul className="text-start mt-3">
                    <li>Anyone can scan</li>
                    <li>No personal info shown</li>
                    <li>They can send you a message securely</li>
                  </ul>
                </Card.Text>
                <Button className="w-100">Buy Tags</Button>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6}>
            <Card className="h-100 border-0 shadow text-center pt-2" style={{backgroundColor: '#e9f1ff'}}>
              <div className="text-center w-100 py-3">
                <Image
                  src="/images/service-2.jpg"
                  alt="CATALOGUES"
                  style={{ width: '90%', maxWidth: '100%', height: 'auto' }}
                />
              </div>
              <Card.Body  className="text-start">
                <Card.Title className="fw-bold" style={{ color: '#000' }}>CATALOGUES</Card.Title>
                <Card.Text className="text-muted">
                  For organized collections (keys, tools, inventory).
                  <ul className="text-start mt-3">
                    <li>Private for you and your group</li>
                    <li>Browse and manage collections</li>
                    <li>Recover items easily</li>
                  </ul>
                </Card.Text>
                <Button className="w-100">Create Catalogues</Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Get Started Section */}
      <Container fluid className="py-5 text-center" style={{ backgroundColor: '#e9f1ff' }}>
        <Container>
          <div className="text-center mb-4">
            <div className="d-flex align-items-center justify-content-center mb-2">
              <div style={{ height: '1px', backgroundColor: '#ccc', width: '60px', marginRight: '10px' }}></div>
              <span className="text-uppercase text-primary" style={{ letterSpacing: '2px', fontWeight: 600 }}>Started</span>
              <div style={{ height: '1px', backgroundColor: '#ccc', width: '60px', marginLeft: '10px' }}></div>
            </div>
            <h3 className="text-black fw-bold">Get Started in Minutes</h3>
            <p className="text-muted">It's Easy to begin securing your valuable with our simple setup process.</p>
          </div>
          <Row className="g-4">
            {getStartedSteps.map((step, idx) => (
              <Col md={4} key={idx}>
                <Card className="h-100 border-0 shadow-sm text-center">
                  <div className="text-center w-100 py-4">
                    <Image
                      src={step.image}
                      alt={step.title}
                      style={{ width: '80px', maxWidth: '100%', height: 'auto' }}
                    />
                  </div>
                  <Card.Body>
                    <h5 className="fw-bold" style={{ color: '#000' }}>{step.title}</h5>
                    <p className="text-muted">{step.description}</p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          <Button className="mt-5 px-5">Choose Your Plan</Button>
        </Container>
      </Container>

      {/* FAQ Section */}
      {/* FAQ Section */}
      <Container className="py-5" id="faq">
        <div className="text-center mb-4">
          <div className="d-flex align-items-center justify-content-center mb-2">
            <div style={{ height: '1px', backgroundColor: '#ccc', width: '60px', marginRight: '10px' }}></div>
            <span className="text-uppercase text-primary" style={{ letterSpacing: '2px', fontWeight: 600 }}>Faq</span>
            <div style={{ height: '1px', backgroundColor: '#ccc', width: '60px', marginLeft: '10px' }}></div>
          </div>
          <h3 className="text-black fw-bold">Frequently Asked Questions</h3>
          <p className="text-muted">Find answers to common question about our service and how it works.</p>
        </div>
        <Row className="g-4">
          {faqs.map((faq, idx) => {
            const isOpen = activeKey === idx;
            return (
              <Col md={6} key={idx}>
                <div className="h-100">
                  <Card
                    className="border-0 shadow-sm"
                    style={{ backgroundColor: isOpen ? '#0D6EFD' : '#e9f1ff', color: isOpen ? '#fff' : '#000' }}
                  >
                    <Card.Body className="d-flex flex-column justify-content-between h-100">
                      <div
                        onClick={() => toggleAccordion(idx)}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          cursor: "pointer"
                        }}
                      >
                        <h5 className="fw-bold mb-0" style={{ color: isOpen ? '#fff' : '#000' }}>{faq.question}</h5>
                        <span style={{ color: isOpen ? '#fff' : '#000' }}>{isOpen ? <FaMinus /> : <FaPlus />}</span>
                      </div>
                      {isOpen && (
                        <p className="mt-3 mb-0" style={{ color: '#fff' }}>{faq.answer}</p>
                      )}
                    </Card.Body>
                  </Card>
                </div>
              </Col>
            );
          })}
        </Row>
      </Container>

      {/* Final CTA Section */}
      <Container fluid className="py-5 bg-primary text-white text-center">
        <h3 className="mb-3 fw-bold">Ready to Secure Your Stuff?</h3>
        <p className="mb-4">Join thousands of satisfied customers who trust QRKey to <br />protect their valuables while Maintaining their Privacy.</p>
        <Button variant="light" className="me-3 px-4">Buy Your Tags</Button>
        <Button variant="outline-light">Contact Us</Button>
      </Container>

      {/* Footer */}
      <footer className="pt-5" style={{ backgroundColor: '#fff' }}>
        <Container>
          <Row className="g-4 pb-4 border-bottom">
            <Col md={3}>
              <Image src="/images/logo.png" height={30} className="mb-3" />
              <p className="text-muted small">Secure, smart labels for everything you value.</p>
              <div className="d-flex gap-3 mt-4">
                <a href="#"><Image src="/images/twitter.png" width={32} /></a>
                <a href="#"><Image src="/images/linkedIn.png" width={32} /></a>
                <a href="#"><Image src="/images/facebook.png" width={32} /></a>
                <a href="#"><Image src="/images/instagram.png" width={32} /></a>
              </div>
            </Col>

            <Col md={3}>
              <h6 className="fw-bold text-dark mb-3">Products</h6>
              <ul className="list-unstyled text-muted">
                <li><a href="#" className="text-muted text-decoration-none">QR Tags</a></li>
                <li><a href="#" className="text-muted text-decoration-none">Catalogues</a></li>
                <li><a href="#" className="text-muted text-decoration-none">Premium Tags</a></li>
                <li><a href="#" className="text-muted text-decoration-none">Business Solution</a></li>
                <li><a href="#" className="text-muted text-decoration-none">API Access</a></li>
              </ul>
            </Col>

            <Col md={3}>
              <h6 className="fw-bold text-dark mb-3">Company</h6>
              <ul className="list-unstyled text-muted">
                <li><a href="#" className="text-muted text-decoration-none">Home</a></li>
                <li><a href="#" className="text-muted text-decoration-none">About us</a></li>
                <li><a href="#" className="text-muted text-decoration-none">How it work</a></li>
                <li><a href="#" className="text-muted text-decoration-none">Services</a></li>
                <li><a href="#" className="text-muted text-decoration-none">Contact us</a></li>
              </ul>
            </Col>

            <Col md={3}>
              <h6 className="fw-bold text-dark mb-3">Subscribe Newsletter</h6>
              <Form className="pt-5">
                <div style={{ backgroundColor: '#f0f6ff', borderRadius: '50px', padding: '4px 10px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Form.Control
                    type="email"
                    placeholder="Enter Email Address"
                    className="border-0 bg-transparent px-2 shadow-none"
                    style={{ flex: 1 }}
                  />
                  <Button variant="primary" className="rounded-circle d-flex align-items-center justify-content-center" style={{ width: '36px', height: '36px' }}>
                    <Image src="/images/button.png" alt="Send" width={18} />
                  </Button>
                </div>
              </Form>
            </Col>
          </Row>

          <div className="text-center pt-3 pb-2">
            <small className="text-muted">© 2025 <span className="fw-bold text-primary">QRKey</span>. All Rights Reserved.</small>
          </div>
        </Container>
      </footer>
    </div>
  );
};

export default HomePage;
